<template>
  <div>
    <h4>
      {{ JSON.parse(element.info).name ?
      JSON.parse(element.info).name : element.widget_master.name }}
    </h4>
    <div v-html="decodeHtmlEntities(JSON.parse(element.info).html)"/>
  </div>
</template>

<script>

import he from 'he';

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },

  methods: {
    decodeHtmlEntities(str) {
      return he.decode(str);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jHtmlWidget.vue